export default __webpack_public_path__ + "static/media/census-per-capita.5f8cad3e.svg";